import { createRouter, createWebHistory } from 'vue-router'
import axios from 'axios'
import { useOfferStore } from '../stores/offer'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: { public: true }
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../views/Products.vue'),
    meta: { public: true }
  },
  {
    path: '/products/:id',
    name: 'ProductDetail',
    component: () => import('../views/ProductDetail.vue'),
    meta: { public: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { public: true }
  },
  {
    path: '/mfa',
    name: 'MFA',
    component: () => import('../views/MFA.vue'),
    meta: { public: true }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/Home.vue'), // Temporary redirect to home
    meta: { public: true }
  },
  {
    path: '/contact',
    name: 'Contact', 
    component: () => import('../views/Home.vue'), // Temporary redirect to home
    meta: { public: true }
  },
  {
    path: '/cart',
    name: 'Cart',
    component: () => import('../views/Cart.vue'),
    meta: { public: true }
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: () => import('../views/Checkout.vue'),
    meta: { public: true }
  },
  {
    path: '/order-confirmation/:orderNumber',
    name: 'OrderConfirmation',
    component: () => import('../views/OrderConfirmation.vue'),
    meta: { public: true }
  },

  // 404 catch-all - redirect to login or home based on auth status
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: to => {
      const token = localStorage.getItem('token')
      if (token) {
        // User is logged in, redirect to home
        return '/'
      } else {
        // User is not logged in, redirect to login
        return '/login'
      }
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.path === from.path) return false
    return { left: 0, top: 0 }
  }
})

// Navigation guard
router.beforeEach((to, from, next) => {
  useOfferStore().capture(to.query, to.hash)
  // Fragments never reach access logs. Remove the credential from the visible
  // URL after saving it in this tab's session, before rendering external links.
  if (to.hash.startsWith('#claim=')) return next({ path: to.path, query: to.query, hash: '', replace: true })
  const token = localStorage.getItem('token')
  
  // Set auth header if token exists
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  }
  
  // Public routes don't require auth
  if (to.meta.public) {
    return next()
  }
  
  // All other routes require auth
  if (!token) {
    return next('/login')
  }
  
  next()
})

export default router
